import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { StartRoutingModule } from './start-routing.module';
import { StartComponent } from './start.component';

import { SharedModule } from '@shared';
import { ButtonModule } from '../../modules-ui';
import { TranslocoModule } from '@ngneat/transloco';
import {
  StartPageLendingModule
} from './lazy-components/start-page-lending-content/start-page-lending-content.component';
import { StartPageSliderModule } from './lazy-components/start-page-slider/start-page-slider.component';
import { FakeSearchModule } from '../../modules-ui/blocks-ui';
import { InputSearchModule } from '../../modules-ui/action-elements';
import { StaticFooterModule } from 'src/app/modules-ui/layouts';

@NgModule({
  declarations: [StartComponent],
  imports: [
    CommonModule,
    StartRoutingModule,
    ButtonModule,
    TranslocoModule,
    SharedModule,
    FakeSearchModule,
    InputSearchModule,
    StartPageSliderModule,
    StartPageLendingModule,
    StaticFooterModule
  ]
})
export class StartModule { }
